import { render, staticRenderFns } from "./ApplicantList.vue?vue&type=template&id=55f9c1b2&scoped=true&"
import script from "./ApplicantList.vue?vue&type=script&lang=js&"
export * from "./ApplicantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9c1b2",
  null
  
)

export default component.exports